import React from 'react';
import { Link } from 'react-router-dom';
import './ProductCard.css';

const ProductCard = ({ product }) => {
  const thumbnail = product.images?.[0] || product.thumbnail;

  return (
    <div className="product-card">
      <Link to={`/produto/${product.id}`} className="product-image-link">
        <div className="product-image">
          {thumbnail ? (
            <img
              src={thumbnail}
              alt={product.name}
              className="product-image-content"
              loading="lazy"
            />
          ) : (
            <div className="product-image-placeholder">
              <span>HAKA</span>
            </div>
          )}
        </div>
      </Link>
      <div className="product-info">
        <Link to={`/produto/${product.id}`} className="product-name-link">
          <h3 className="product-name">{product.name}</h3>
        </Link>
        <p className="product-price">{product.price}</p>
        <Link to={`/produto/${product.id}`} className="product-buy-btn">
          <span>Ver camiseta</span>
        </Link>
      </div>
    </div>
  );
};

export default ProductCard;
